import { ProfileUserInfo } from "./ProfileUserInfo";
import { ProfileMenuSection } from "./ProfileMenuSection";
import { BottomNavigation } from "../ui/BottomNavigation";
import { useEffect, useState } from "react";
import { User } from "@nusrif/types";
import { getUser, getUserFromServer } from "@nusrif/services";

export const MyProfilePage = () => {
  const [user, setUser] = useState<User | null>(null);

  useEffect(() => {
    let isMounted = true;

    const loadUser = async () => {
      // Step 1: Use cached user immediately (if exists)
      const cachedUser = getUser();
      if (cachedUser?.onboarded && isMounted) {
        setUser(cachedUser);
      }

      // Step 2: Fetch updated user from server
      try {
        await getUserFromServer();
        const freshUser = getUser();
        if (isMounted) {
          setUser(freshUser);
        }
      } catch (error) {
        console.error("Failed to fetch user:", error);
      }
    };

    loadUser();

    // Cleanup to avoid state updates if unmounted
    return () => {
      isMounted = false;
    };
  }, []);

  return (
    <div className="w-full bg-white flex flex-col">
      {/* Scrollable content area with proper spacing */}
      <div className="flex-1 pb-[70px] px-5 space-y-6 pt-5">
        {user?.onboarded && <ProfileUserInfo />}

        {/* Menu Sections */}
        <ProfileMenuSection />
      </div>

      {/* Fixed bottom navigation */}
      <BottomNavigation />
    </div>
  );
};
